import { createContext } from 'react';

/**
 * True under `AcademicYearRequired`, which already notes a past working year above the
 * page: a page's own `YearScopeNotice` then only speaks for a year other than the
 * working year.
 */
export const WorkingYearNoticeShown = createContext(false);
